import { s as o } from "./swup-D02q0XU9.js";
import "./Swup.modern-cdyLtNvW.js";
import "./__dev__-BPvTvNaV.js";
const y = async ({ container: t, exclude: n }) => {
  if (typeof o.preload != "function") return;
  const u = Array.isArray(t) ? t : [t], a = Array.isArray(n) ? n : [n], f = u.flatMap((c) => [...c.querySelectorAll("a[href]")].map((s) => {
    const r = s.getAttribute("href");
    if (!r || r.startsWith("#") || r.startsWith("mailto:") || r.startsWith("tel:") || r.startsWith("javascript:") || s.hasAttribute("data-no-swup")) return null;
    const l = new URL(r, window.location.origin);
    if (l.origin !== window.location.origin) return null;
    const e = l.toString();
    return (a == null ? void 0 : a.some((p) => e.includes(p))) ? null : e;
  }).filter(Boolean)), i = [...new Set(f)];
  i.length && await o.preload(i);
};
export {
  y as s
};
